<section class="error-container">
    <div class="error-info">
        <div class="breadcrumb-back" (click)="goBack()">
            <span class="breadcrumb-theme-left"
                ><i><vn-icon name="theme-left" size="16" class="error-left-icon"></vn-icon></i
            ></span>
        </div>
        <div class="content-name">
            <ng-content select="[item-header]"></ng-content>
        </div>
    </div>
</section>
